import customEventBus from '@common/scripts/libs/eventBus';
import { addURLParameter } from '@common/utils/urlutils';
import { removeChatInfosFromStorage } from '@components/chat/ChatUtils';
import ErrorBox from '@components/common/ErrorBox';
import Button from '@ui/button/Button';
import FormField from '@ui/formfield/FormField';
import analytics from '@utils/analytics';
import api from '@utils/api';
import classNames from 'classnames';
import createDecorator from 'final-form-focus';
import React, { useRef } from 'react';
import { Form } from 'react-final-form';
import ReCAPTCHA from 'react-google-recaptcha';
import { useTranslation } from 'react-i18next';
const focusOnError = createDecorator(); // must be outside the component
const LoginPasswordForm = (props) => {
    const { t } = useTranslation();
    const [errors, setErrors] = React.useState([]);
    const [isSubmitting, setIsSubmitting] = React.useState(false);
    const reCaptchaRef = useRef();
    const showRecaptcha = window.recapchaCfg && JSON.parse(window.recapchaCfg).loginButton;
    const redirectAfterSuccess = new URLSearchParams(window.location.search).get('redirectToPdp');
    const rurl = new URLSearchParams(window.location.search).get('rurl');
    const onSubmit = async (values) => {
        setErrors([]);
        setIsSubmitting(true);
        values.loginEmail = props.loginEmail;
        if (showRecaptcha) {
            const token = await reCaptchaRef.current.executeAsync();
            values.gr3Token = token;
        }
        if (!props.doubleOptIn && window.isClothing) {
            props.setLoginStep('doubleOptIn');
        }
        else {
            api
                .login(values, redirectAfterSuccess, rurl)
                .then((data) => {
                if (data.success) {
                    (props === null || props === void 0 ? void 0 : props.updateLoggeedStatus) && (props === null || props === void 0 ? void 0 : props.updateLoggeedStatus(data.authenticatedCustomer));
                    removeChatInfosFromStorage();
                    analytics.login();
                    if (props === null || props === void 0 ? void 0 : props.linkreload) {
                        window.location.href = props.linkreload;
                    }
                    else if (props.reloadComponent) {
                        window.loggedin = true;
                        customEventBus.emit('account:update', { firstName: data === null || data === void 0 ? void 0 : data.authenticatedCustomer });
                    }
                    else if (data.redirectUrl) {
                        window.location.href = data.redirectUrl;
                    }
                    else {
                        window.location.reload();
                    }
                }
                if (data.error && data.error.length > 0) {
                    if (data.error[0] == 'migration') {
                        window.location.href = addURLParameter(props.forgotpasswordform, 'migration', 'true');
                    }
                    else {
                        setErrors(data.error);
                        setIsSubmitting(false);
                    }
                }
            })
                .catch((e) => {
                setErrors([e]);
                setIsSubmitting(false);
            });
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "row" },
            React.createElement("div", { className: props.singleColumn ? 'col-12' : 'col-12 col-sm-8' },
                React.createElement("p", { className: "primary-xs" },
                    t('account.welcomeback'),
                    " ",
                    React.createElement("b", null, props.loginEmail)),
                React.createElement("p", { className: "primary-xs" }, window.isClothing ? t('login.clothing.insertpassword') : t('login.insertpassword'))),
            React.createElement("div", { className: props.singleColumn ? 'col-12 mt-12' : 'col-12 col-sm-4 sm-text-right' },
                React.createElement("button", { onClick: () => props.setLoginStep('email'), className: "link primary-xs" }, t('login.editemail')))),
        React.createElement(Form, { onSubmit: onSubmit, decorators: [focusOnError], render: ({ handleSubmit, form, submitting, pristine, values }) => (React.createElement("form", { onSubmit: handleSubmit, className: "mt-24" },
                React.createElement("div", { className: classNames('formfields', { 'has-password-error': errors.length >= 1 }) },
                    React.createElement(FormField, { name: "loginPassword", label: t('label.password'), type: "password", autocomplete: "current-password", showPassword: true, required: true }),
                    React.createElement("div", { className: "forgot-pw-error" },
                        React.createElement("div", { className: "forgot-pw-error__pw" },
                            React.createElement("a", { className: classNames('button', 'forgot-pw'), href: props.forgotpasswordform || window.forgotpasswordform, onClick: () => {
                                    props.onForgotPassword && props.onForgotPassword();
                                    analytics.forgotPasswordOne();
                                } }, t('login.forgottenpassword'))),
                        React.createElement("div", { className: "forgot-pw-error__error" },
                            React.createElement(ErrorBox, { errors: errors }))),
                    !window.clickfromstore && (React.createElement("div", { className: "remember-me" },
                        props.rememberme && React.createElement(FormField, { name: "loginRememberMe", label: t('label.rememberme'), type: "checkbox", checked: true }),
                        !window.isClothing && (React.createElement("a", { href: props.privacypolicy || window.privacypolicyurl, target: "_blank", rel: "noreferrer", className: "privacy-link primary-xs" }, t('login.privacypolicy')))))),
                showRecaptcha && React.createElement(ReCAPTCHA, { className: "recaptcha", sitekey: window.atob(window.recapchaData), size: "invisible", ref: reCaptchaRef }),
                React.createElement(Button, { type: "submit", disabled: isSubmitting, cls: ['button--primary'] }, t('login.logintomymoncler')))) })));
};
export default LoginPasswordForm;
